import { cx } from '@linaria/core';
import { useRef } from 'react';
import { breakpoints } from '@ui/css';
import { usePagination, Slider, CircularButton } from '@ui/kit';
import { useComponentEntry } from '@utils/component-framework';
import { useMatchBreakpoint, useChangeEffect } from '@utils/react';
import { Card } from '../molecules/card/_card.js';
import { Steps } from '../molecules/steps/steps.js';
import { wrapper, content, sliderWrapper, card, button, prevButton, nextButton } from './card-slider.style.js';
import { useDynamicItemsPerPage } from './hook.items-per-page.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useUpdateLocationMutation } from '../state/mutation.update-location.js';

function CardSlider(props) {
  const isMobile = useMatchBreakpoint(breakpoints.mobile);
  const entryIndex = useComponentEntry(props.entryKey,
  // NB: We wish to start on the second card (!) to ensure that we do no
  // end up with a lot of empty space to the left of the centered card.
  {
    select: entry => entry?.data.currentIndex ?? (props.data.cards.length > 1 && !isMobile ? 1 : 0)
  });
  const sliderRef = useRef(null);
  const pagination = usePagination(props.data.cards, {
    sliderRef,
    infinite: false,
    type: "items",
    initialIndex: entryIndex.data
  });
  const updateLocation = useUpdateLocationMutation(props.entryKey);
  const handleGoForward = () => {
    updateLocation(pagination.activeItemIndex + 1);
    pagination.goForwards();
  };
  const handleGoBackward = () => {
    updateLocation(pagination.activeItemIndex - 1);
    pagination.goBackwards();
  };
  useChangeEffect(() => {
    pagination.goTo(entryIndex.data ?? 0);
    setTimeout(() => {
      sliderRef.current?.querySelector("[tabIndex='0']")?.focus();
    }, 250);
  }, [props.entryKey]);
  useDynamicItemsPerPage(sliderRef);
  return /*#__PURE__*/jsxs("section", {
    "data-flashcards": true,
    className: wrapper,
    ref: props.ref,
    "data-context": props.context,
    children: [/*#__PURE__*/jsx(Steps, {
      entryKey: props.entryKey,
      cards: props.data.cards,
      pagination: pagination
    }), /*#__PURE__*/jsxs("div", {
      className: content,
      children: [/*#__PURE__*/jsx("div", {
        className: sliderWrapper,
        children: /*#__PURE__*/jsx(Slider, {
          wrapperRef: sliderRef,
          pagination: pagination,
          items: props.data.cards,
          infinite: false,
          focusTarget: "center",
          children: (item, extra) => /*#__PURE__*/jsx("div", {
            className: card,
            children: /*#__PURE__*/jsx(Card, {
              card: item,
              globalLabels: props.data.labels,
              index: extra.index,
              entryKey: props.entryKey,
              visible: extra.isVisible,
              pagination: pagination
            })
          })
        })
      }), /*#__PURE__*/jsx("div", {
        className: cx(button, prevButton),
        "data-disabled": !pagination.canGoBackwards,
        children: /*#__PURE__*/jsx("div", {
          children: /*#__PURE__*/jsx(CircularButton, {
            onClick: handleGoBackward,
            inversed: true,
            tabIndex: -1,
            size: "large",
            disabled: !pagination.canGoBackwards
          })
        })
      }), /*#__PURE__*/jsx("div", {
        className: cx(button, nextButton),
        "data-disabled": !pagination.canGoForwards,
        children: /*#__PURE__*/jsx("div", {
          children: /*#__PURE__*/jsx(CircularButton, {
            onClick: handleGoForward,
            tabIndex: -1,
            size: "large",
            disabled: !pagination.canGoForwards
          })
        })
      })]
    })]
  });
}

export { CardSlider };
//# sourceMappingURL=card-slider.js.map
